import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import styled from "../common/styled";
import { validConfig } from '../config'
import * as API from "../common/api";
import * as actions from "../actions";
import { compose, checkForm, setIn } from "../common/utils";
import { signIn, login, authUser, forgotPassword } from "../common/aws_lib";

const { Text, Image, View } = styled;

const OuterWrapper = styled.View`
  position: relative;
  height: 100%;
`;

const Wrapper = styled.View`
  padding: 15px;
  width: 400px;
  height: 560px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -280px 0 0 -200px;
`;

const FormGroup = styled.View`
  margin-bottom: 20px;
`;

const labelHeight = 30;

const Label = styled.View`
  height: ${labelHeight}px;
`;

const LabelText = styled.Text`
  line-height: ${labelHeight}px;
  color: #fff;
  font-size: 16px;
`;

const inputHeight = 30;

const InputBox = styled.View`
  border: 1px solid rgba(255,255,255,0.5);
  border-radius: 5px;
  height: ${inputHeight}px;
`;

const TextInput = styled.styled.input`
display: block;
width: 100%;
padding: 0;
border: 0;
height: ${inputHeight}px;
line-height: ${inputHeight}px;
font-size: 14px;
outline: none;
background: transparent !important;
color: white;
`;

const buttonHeight = 40;

const SubmitButton = styled.Button`
  width: 100%;
  height: ${buttonHeight * 1.2}px;
  line-height: ${buttonHeight * 1.2}px;
  border: 1px solid white;
  border-radius: 5px;
  text-align: center;
  background: none;
`;

const ButtonText = styled.Text`
  font-size: 16px;
  color: #fff;
`;

const ErrorMessage = styled.View`
  padding: 5px 0;
  line-height: 18px;
  color: #f78a8a;
  font-size: 14px;
`;

const checks = [
  {
    related: ["username"],
    check: s => s && s.length,
    errMsg: () => "Username is required"
  },
  {
    related: ["site"],
    check: s => s && s.length,
    errMsg: () => "site is required"
  },
  {
    related: ["password"],
    check: s => s && s.length,
    errMsg: () => "Password is required"
  }
];

const checkLoginForm = checkForm(checks);

class Login extends React.Component {
  state = {
    formData: {
      site: '',
      username: '',
      password: '',
    },
    errMsgs: {}
  };

  onChangeField = (key, val) => {
    this.setState(setIn(["formData", key], val, this.state));
  };

  validateForm = fields => {
    const data = this.state.formData;
    const errMsgs = checkLoginForm(data, fields);
    const newErrMsgs =
      fields && fields.length > 0
        ? { ...this.state.errMsgs, ...errMsgs }
        : errMsgs;
    const hasError =
      Object.keys(newErrMsgs).filter(key => newErrMsgs[key]).length > 0;

    if (!fields && hasError) {
      const firstError = Object.keys(errMsgs)
        .map(key => errMsgs[key])
        .filter(x => !!x)[0];
      toast.error(firstError);
    }

    this.setState({ errMsgs: newErrMsgs });
    return !hasError;
  };

  onSubmitForm = () => {
    if (!this.validateForm()) return;

    const data = this.state.formData;
    let key = data.site.replace(/ /g,'')
    key = key.toLowerCase()

    if (!validConfig(key)) {
      this.setState({
        errMsgs: {
          ...this.state.errMsgs,
          site: 'Invalid site'
        }
      })
      return
    }
    localStorage.setItem('SITE_NAME', key)

    return actions.wrapLoading(
      this.props,
      login(data.username, data.password).then(
        data => {
          toast.success("Successfully Logged In");

          setTimeout(() => {
            this.props.history.push("/");
          }, 500);
        },
        e => {
          const msg = e.message;
          toast.error(msg);
        }
      )
    );
  };

  componentDidMount() {
    this.setHeader();
    document.body.classList.add("landing");

    authUser()
      .then(isLogined => {
        if (isLogined) {
          this.props.history.push("/");
        }
        return isLogined;
      })
      .catch(() => { });
  }

  componentWillUnmount() {
    document.body.classList.remove("landing");
  }

  setHeader() {
    this.props.setHeader(() => ({
      title: "",
      left: null,
      right: null
    }));
  }

  render() {
    return (
      <OuterWrapper>
        <Wrapper>
          <div className="loginTitle-wrapper">
            <img className="loginLogo" src="/icon512.png" title="Smart Image Gallery" />
            <h1 className="loginTitle">Smart Image Gallery</h1>
          </div>
          <FormGroup>
            <Label>
              <LabelText>Site</LabelText>
            </Label>
            <InputBox>
              <TextInput
                type="text"
                placeholder=""
                value={this.state.formData.site}
                onChange={ec =>
                  this.onChangeField("site", ec && ec.target.value)
                }
                onBlur={() => this.validateForm(["site"])}
              />
            </InputBox>
            <ErrorMessage show={this.state.errMsgs.site}>
              {this.state.errMsgs.site}
            </ErrorMessage>
          </FormGroup>

          <FormGroup>
            <Label>
              <LabelText>Username</LabelText>
            </Label>
            <InputBox>
              <TextInput
                type="text"
                placeholder=""
                value={this.state.formData.username}
                onChange={ec =>
                  this.onChangeField("username", ec && ec.target.value)
                }
                onBlur={() => this.validateForm(["username"])}
              />
            </InputBox>
            <ErrorMessage show={this.state.errMsgs.username}>
              {this.state.errMsgs.username}
            </ErrorMessage>
          </FormGroup>

          <FormGroup>
            <Label>
              <LabelText>Password</LabelText>
            </Label>
            <InputBox>
              <TextInput
                type="password"
                placeholder=""
                value={this.state.formData.password}
                onChange={ec =>
                  this.onChangeField("password", ec && ec.target.value)
                }
                onBlur={() => this.validateForm(["password"])}
              />
            </InputBox>
            <ErrorMessage show={this.state.errMsgs.password}>
              {this.state.errMsgs.password}
            </ErrorMessage>
          </FormGroup>

          <FormGroup
            className="loginButton-wrapper">
            <Button
              className="loginButton"
              outline
              color="secondary"
              onClick={this.onSubmitForm}
            >
              <ButtonText>Login</ButtonText>
            </Button>
          </FormGroup>
        </Wrapper>
      </OuterWrapper>
    );
  }
}

export default compose(
  connect(
    state => ({
      orderForm: state.userData.orderForm,
      bookingForm: state.userData.bookingForm
    }),
    dispatch => bindActionCreators({ ...actions }, dispatch)
  ),
  withRouter
)(Login);
